import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { UrlService } from '@core/services/url/url.service';

import * as vsModel from '@core/models/version-share.model';
import { Version } from '@core/objects/version';

@Injectable({
    providedIn: 'root'
})
/**
 * Service to use utils for new bubbles object set according to 
 * new feedback types and new features
 * <diego@twonas.com> at 8/12/2023
 */
export class VersionSharesService {

    constructor(
        protected url: UrlService, 
        protected http: HttpClient,
    ) {}

    /**
     * 
     * @param share an object for each user share in the same version
     * with the status according the type of feedback in the bubble.
     * @returns string with the color to display
     */
    public getVersionShareBubbleColor(share: vsModel.VersionShare) : string {
        switch (share.type) {
            case vsModel.VersionShareType.UPLOAD_VERSION_TYPE:
                return vsModel.UploadVersionStatusColorValues[share.status.status_code];
                break;
            case vsModel.VersionShareType.FEEDBACK_TYPE:
                return vsModel.FeedbackStatusColorValues[share.status.status_code];
                break;
            case vsModel.VersionShareType.APPROVAL_TYPE:
                return vsModel.ApprovalStatusColorValues[share.status.status_code];
                break;
            default:
                return  vsModel.FeedbackStatusColorValues[0];
                break;
        }
    }

    // Load bubbles for a version without store (used in logbook)
    getVersionShares$(version: Version) {
        return this.http
        .get(this.url.build("/versions/" + version.id + "/shares"));
    }
}